// A 3x5 pixel font for labels drawn inside pixel scenes (e.g. the UNISWAP POOL crucible).
const G: Record<string, string> = {
  A: '010101111101101',
  B: '110101110101110',
  C: '011100100100011',
  D: '110101101101110',
  E: '111100110100111',
  F: '111100110100100',
  G: '011100101101011',
  H: '101101111101101',
  I: '111010010010111',
  J: '001001001101010',
  K: '101101110101101',
  L: '100100100100111',
  M: '101111111101101',
  N: '110101101101101',
  O: '010101101101010',
  P: '110101110100100',
  Q: '010101101110011',
  R: '110101110101101',
  S: '011100010001110',
  T: '111010010010010',
  U: '101101101101111',
  V: '101101101101010',
  W: '101101111111101',
  X: '101101010101101',
  Y: '101101010010010',
  Z: '111001010100111',
  '0': '111101101101111',
  '1': '010110010010111',
  '2': '110001010100111',
  '3': '110001010001110',
  '4': '101101111001001',
  '5': '111100110001110',
  '6': '011100111101111',
  '7': '111001010010010',
  '8': '111101111101111',
  '9': '111101111001110',
  '.': '000000000000010',
  ':': '000010000010000',
  '-': '000000111000000',
  '#': '101111101111101',
  '/': '001001010100100',
  '%': '101001010100101',
  '!': '010010010000010',
  '×': '000101010101000',
  ' ': '000000000000000',
};

export const textWidth = (s: string) => Math.max(0, s.length * 4 - 1);

/** Draw uppercase text with its top-left at (x, y) in the current fillStyle. */
export function drawText(ctx: CanvasRenderingContext2D, s: string, x: number, y: number) {
  let cx = Math.round(x);
  const cy = Math.round(y);
  for (const ch of s.toUpperCase()) {
    const g = G[ch] ?? G[' ']!;
    for (let i = 0; i < 15; i++) if (g.charCodeAt(i) === 49) ctx.fillRect(cx + (i % 3), cy + Math.floor(i / 3), 1, 1);
    cx += 4;
  }
}
